import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20landscape%20with%20glowing%20red%20data%20streams%20and%20encrypted%20text%20flowing%20through%20cyberspace%2C%20shadowy%20abstract%20geometric%20patterns%2C%20deep%20black%20background%20with%20subtle%20crimson%20and%20amber%20light%20accents%2C%20futuristic%20surveillance%20aesthetic%2C%20atmospheric%20and%20moody&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
          alt="黑网料 - 深度揭秘与内幕资讯聚合平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-8">
          <i className="ri-flashlight-line text-primary-400 text-sm"></i>
          <span className="text-primary-400 text-sm font-medium">已收录 12,860+ 条深度内幕资讯</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-foreground-50 leading-tight mb-6 tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>
          穿透信息迷雾
          <br />
          <span className="text-primary-400">洞察真相背后</span>
        </h1>

        <p className="text-foreground-400 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          黑网料专注收录网络深度内幕、爆料资讯与隐秘信息。汇聚真实黑网料来源，
          帮助您快速获取被删除、被屏蔽的第一手内幕内容，洞察信息背后的真相。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/shehui-baoliao"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            <i className="ri-compass-3-line mr-2"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg bg-background-800/60 text-foreground-200 font-medium text-base hover:bg-background-700/60 border border-background-700/40 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-information-line mr-2"></i>
            了解我们
          </Link>
        </div>

        <div className="mt-14 flex items-center justify-center gap-8 text-foreground-600 text-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground-200" style={{ fontFamily: "var(--font-heading)" }}>12,860+</div>
            <div className="mt-1">内幕资讯</div>
          </div>
          <div className="w-px h-10 bg-background-700"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground-200" style={{ fontFamily: "var(--font-heading)" }}>6</div>
            <div className="mt-1">核心分类</div>
          </div>
          <div className="w-px h-10 bg-background-700"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground-200" style={{ fontFamily: "var(--font-heading)" }}>3,200+</div>
            <div className="mt-1">独家爆料</div>
          </div>
          <div className="w-px h-10 bg-background-700"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground-200" style={{ fontFamily: "var(--font-heading)" }}>890万+</div>
            <div className="mt-1">月阅读量</div>
          </div>
        </div>
      </div>
    </section>
  );
}